import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { Envelope, Phone, ChatCircleDots } from "@phosphor-icons/react";

const FAQS = [
  {
    q: "How do I make a booking?",
    a: "Browse stays, pick your dates and guests, hit Reserve Now, and complete payment. You'll get an instant confirmation on the Bookings page.",
  },
  {
    q: "Which payment methods are supported?",
    a: "We support UPI (GPay, PhonePe, Paytm, BHIM), all major credit/debit cards, netbanking, and popular wallets via secure gateways.",
  },
  {
    q: "Can I cancel or modify a booking?",
    a: "Every property has its own cancellation policy shown at checkout. Contact concierge for modifications — most changes can be handled within 24 hours.",
  },
  {
    q: "Is my payment information secure?",
    a: "Yes. Payments are processed via PCI-DSS compliant gateways. Zyro never stores your card details on its servers.",
  },
  {
    q: "How is Zyro different from a typical booking site?",
    a: "We curate. Every property on Zyro is hand-picked for its design, hospitality, and story — no generic budget listings.",
  },
  {
    q: "Do I need an account to book?",
    a: "Yes — an account keeps your trips organized and lets you write reviews and contact hotels directly.",
  },
];

export default function HelpPage() {
  return (
    <div className="max-w-4xl mx-auto px-6 lg:px-10 py-16">
      <p className="text-xs tracking-[0.3em] uppercase text-gold mb-3">We're here to help</p>
      <h1 className="font-serif text-4xl lg:text-5xl text-midnight mb-4">Help Center</h1>
      <p className="text-neutral-600 mb-12 max-w-2xl">
        Answers to the questions our guests ask most often. Can't find what you're looking for?
        Our 24×7 concierge is a message away.
      </p>

      <Accordion type="single" collapsible className="mb-16" data-testid="faq-accordion">
        {FAQS.map((f, i) => (
          <AccordionItem key={i} value={`item-${i}`}>
            <AccordionTrigger className="text-left font-serif text-lg text-midnight hover:text-gold">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-neutral-600 leading-relaxed">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>

      <div className="bg-midnight text-bone rounded-2xl p-10">
        <p className="text-xs tracking-[0.3em] uppercase text-gold mb-3">Still need help?</p>
        <h2 className="font-serif text-3xl mb-8">Reach our concierge</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="flex items-start gap-4">
            <Envelope size={24} weight="duotone" className="text-gold shrink-0" />
            <div>
              <p className="text-sm text-neutral-400 uppercase tracking-wider mb-1">Email</p>
              <a href="mailto:conect@zyroapp.in" className="text-bone hover:text-gold" data-testid="help-email">conect@zyroapp.in</a>
            </div>
          </div>
          <div className="flex items-start gap-4">
            <Phone size={24} weight="duotone" className="text-gold shrink-0" />
            <div>
              <p className="text-sm text-neutral-400 uppercase tracking-wider mb-1">Call / WhatsApp</p>
              <a href="tel:+919262592844" className="text-bone hover:text-gold" data-testid="help-phone">+91 92625 92844</a>
            </div>
          </div>
          <div className="flex items-start gap-4">
            <ChatCircleDots size={24} weight="duotone" className="text-gold shrink-0" />
            <div>
              <p className="text-sm text-neutral-400 uppercase tracking-wider mb-1">Live Chat</p>
              <p className="text-bone">24 × 7 concierge</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
